import * as bg from '@gongxigames/framework/static/shared/slot_lang/bg.json';
import * as cs from '@gongxigames/framework/static/shared/slot_lang/cs.json';
import * as da from '@gongxigames/framework/static/shared/slot_lang/da.json';
import * as de from '@gongxigames/framework/static/shared/slot_lang/de.json';
import * as el from '@gongxigames/framework/static/shared/slot_lang/el.json';
import * as en from '@gongxigames/framework/static/shared/slot_lang/en.json';
import * as es from '@gongxigames/framework/static/shared/slot_lang/es.json';
import * as et from '@gongxigames/framework/static/shared/slot_lang/et.json';
import * as fi from '@gongxigames/framework/static/shared/slot_lang/fi.json';
import * as fr from '@gongxigames/framework/static/shared/slot_lang/fr.json';
import * as hr from '@gongxigames/framework/static/shared/slot_lang/hr.json';
import * as hu from '@gongxigames/framework/static/shared/slot_lang/hu.json';
import * as id from '@gongxigames/framework/static/shared/slot_lang/id.json';
import * as it from '@gongxigames/framework/static/shared/slot_lang/it.json';
import * as ja from '@gongxigames/framework/static/shared/slot_lang/ja.json';
import * as ko from '@gongxigames/framework/static/shared/slot_lang/ko.json';
import * as nl from '@gongxigames/framework/static/shared/slot_lang/nl.json';
import * as no from '@gongxigames/framework/static/shared/slot_lang/no.json';
import * as pl from '@gongxigames/framework/static/shared/slot_lang/pl.json';
import * as pt from '@gongxigames/framework/static/shared/slot_lang/pt.json';
import * as ro from '@gongxigames/framework/static/shared/slot_lang/ro.json';
import * as ru from '@gongxigames/framework/static/shared/slot_lang/ru.json';
import * as sk from '@gongxigames/framework/static/shared/slot_lang/sk.json';
import * as sv from '@gongxigames/framework/static/shared/slot_lang/sv.json';
import * as th from '@gongxigames/framework/static/shared/slot_lang/th.json';
import * as tr from '@gongxigames/framework/static/shared/slot_lang/tr.json';
import * as vi from '@gongxigames/framework/static/shared/slot_lang/vi.json';
import * as zh from '@gongxigames/framework/static/shared/slot_lang/zh.json';
import * as ptBr from '@gongxigames/framework/static/shared/slot_lang/pt-br.json';
import * as enSoc from '@gongxigames/framework/static/shared/slot_lang/en_soc.json';
import * as deSoc from '@gongxigames/framework/static/shared/slot_lang/de_soc.json';
import * as esSoc from '@gongxigames/framework/static/shared/slot_lang/es_soc.json';

export const translations = {
    bg,
    cs,
    da,
    de,
    el,
    en,
    es,
    et,
    fi,
    fr,
    hr,
    hu,
    id,
    it,
    ja,
    ko,
    nl,
    no,
    pl,
    pt,
    ro,
    ru,
    sk,
    sv,
    th,
    tr,
    vi,
    zh,
    'pt-br': ptBr,
    de_soc: deSoc,
    en_soc: enSoc,
    es_soc: esSoc
};
